import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getMutationErrorMessage } from '@/lib/api';
import { completePasswordAuthFlow } from '@/lib/utils/postAuthFlow';

export function usePasswordLogin() {
  return useMutation({
    mutationFn: completePasswordAuthFlow,
    onError: (error: unknown) => {
      toast.error(getMutationErrorMessage(error));
    },
  });
}
